const FAQS = [
  {
    q: '6080影视需要注册或付费吗？',
    a: '无需注册、无需付费、无需VIP会员。6080影视依托6080新视觉影视资源，所有影片均可免费在线观看，打开浏览器即可享受高清流畅播放体验。',
  },
  {
    q: '观看高清电影需要安装播放器或插件吗？',
    a: '完全不需要。6080影视采用先进的HTML5播放技术，支持主流浏览器直接播放，无需下载任何播放器、插件或APP，即点即看不缓冲。',
  },
  {
    q: '支持哪些设备观看？画质如何？',
    a: '全面支持电脑、平板和手机浏览器访问，自适应不同屏幕尺寸。所有影片默认高清画质，在良好网络环境下可实现1080P流畅播放，满足大屏观影需求。',
  },
  {
    q: '影片更新频率如何？能找到最新电影吗？',
    a: '片库每日更新，平均每天新增30余部影片。最新院线下线大片、热门网络电影和经典老片都会第一时间同步入库，确保你不错过任何好片。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于6080影视，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <details
              key={i}
              className="group bg-background-100 rounded-lg border border-background-200/60 overflow-hidden"
              open={i === 0}
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="flex-shrink-0 w-6 h-6 hidden group-open:flex items-center justify-center text-foreground-400">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}